// removed by extract-text-webpack-plugin
module.exports = {"note":"Note__note___E9M6q","error":"Note__error___25MIY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Note.scss
// module id = CVI9
// module chunks = 0